export default defineNuxtPlugin(async () => {
  const { loadTranslations } = useTranslations('nothing')
  const { loadCurrentPortal } = usePortals()

  await Promise.all([
    loadTranslations(),
    loadCurrentPortal()
  ])
})
